import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Radio() {
  const [selectedStation, setSelectedStation] = useState<string | null>(null);
  const navigate = useNavigate();

  const radioStations = [
    {
      id: 'novo-tempo',
      name: 'Rádio Novo Tempo',
      description: 'Programação cristã 24 horas',
      genre: 'Gospel/Cristã',
      website: 'https://novotempo.com/radio/',
      image: 'https://public.readdy.ai/ai/img_res/f3073380a7b15aa9ec9428b9603e804f.jpg'
    },
    {
      id: 'vida-fm',
      name: 'Vida FM',
      description: 'Música e mensagens de vida',
      genre: 'Cristã',
      website: 'https://www.vidafm.com.br/',
      image: 'https://readdy.ai/api/search-image?query=Vida%20FM%20radio%20station%2C%20life%20theme%2C%20Christian%20music%20and%20messages%2C%20spiritual%20vitality%2C%20faith-based%20broadcasting&width=300&height=200&seq=radio-vida-fm&orientation=landscape'
    },
    {
      id: 'radio-voz-profetica',
      name: 'Rádio Voz Profética',
      description: 'Palavra profética e adoração',
      genre: 'Profética',
      website: 'https://radiovozprofetica.com/',
      image: 'https://readdy.ai/api/search-image?query=Radio%20Voz%20Profetica%2C%20prophetic%20voice%20theme%2C%20Christian%20prophetic%20ministry%2C%20spiritual%20broadcasting%2C%20biblical%20prophecy&width=300&height=200&seq=radio-voz-profetica&orientation=landscape'
    },
    {
      id: 'mytuner-radio-gospel',
      name: 'MyTuner Radio Gospel',
      description: 'Estações gospel do Brasil reunidas',
      genre: 'Gospel',
      website: 'https://mytuner-radio.com/pt/radio/pais/brazil/genero/gospel-estacoes',
      image: 'https://readdy.ai/api/search-image?query=MyTuner%20Radio%20Gospel%20Brazil%2C%20multiple%20gospel%20stations%20platform%2C%20Brazilian%20Christian%20radio%20directory%2C%20gospel%20music%20collection&width=300&height=200&seq=mytuner-radio-gospel&orientation=landscape'
    }
  ];

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  const openRadioWebsite = (website: string) => {
    window.open(website, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 via-pink-600 to-red-600">
      {/* Header Premium */}
      <header className="bg-white/98 backdrop-blur-lg shadow-2xl border-b-4 border-gradient-to-r from-purple-600 to-pink-600">
        <div className="px-8 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img 
                src="https://static.readdy.ai/image/8fbfc975813ef59021c9f16b313e86f9/f5810bc36c96b4c4a03e9a9aa341e507.png"
                alt="Assembleia de Deus - Missão Europa"
                className="w-20 h-20 sm:w-24 sm:h-24 lg:w-32 lg:h-32 object-contain shadow-2xl rounded-2xl border-4 border-indigo-200"
              />
              <div className="text-center flex-1">
                <h1 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent whitespace-nowrap">
                  <span style={{ fontFamily: '"Agnes", serif' }}>IGREJA AD MISSÃO EUROPA CHURCH</span>
                </h1>
                <p className="text-sm text-gray-600">Church Portugal</p>
              </div>
            </div>

            <nav className="flex items-center space-x-6">
              <button
                onClick={() => navigate('/home')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-home-line text-lg"></i>
                <span>Início</span>
              </button>

              <button
                onClick={() => navigate('/bible')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-book-line text-lg"></i>
                <span>Bíblia</span>
              </button>

              <button
                onClick={() => navigate('/characters')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-user-star-line text-lg"></i>
                <span>Personagens</span>
              </button>

              <button
                onClick={() => navigate('/radio')}
                className="flex items-center space-x-2 px-6 py-3 text-purple-600 bg-purple-100 rounded-xl hover:bg-purple-200 transition-all duration-200 whitespace-nowrap cursor-pointer font-medium shadow-lg"
              >
                <i className="ri-radio-line text-lg"></i>
                <span>Rádio</span>
              </button>

              <button
                onClick={() => navigate('/kids')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-bear-smile-line text-lg"></i>
                <span>Crianças</span>
              </button>

              <button
                onClick={() => navigate('/devotionals')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-heart-line text-lg"></i>
                <span>Devocionais</span>
              </button>

              <button
                onClick={() => navigate('/studies')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-graduation-cap-line text-lg"></i>
                <span>Estudos</span>
              </button>

              <button
                onClick={() => navigate('/prayer-requests')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-hands-line text-lg"></i>
                <span>Oração</span>
              </button>

              <button
                onClick={() => navigate('/gallery')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-gallery-line text-lg"></i>
                <span>Mural</span>
              </button>

              <button
                onClick={() => navigate('/location')}
                className="flex items-center space-x-2 px-6 py-3 text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-map-pin-line text-lg"></i>
                <span>Localização</span>
              </button>

              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 px-6 py-3 text-red-600 hover:bg-red-50 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer font-medium"
              >
                <i className="ri-logout-box-line text-lg"></i>
                <span>Sair</span>
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Banner Premium */}
      <div className="relative h-96 bg-gradient-to-r from-purple-800 via-pink-800 to-red-800 overflow-hidden">
        <div className="absolute inset-0 bg-black/40"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Christian%20radio%20broadcasting%20studio%20with%20microphones%2C%20headphones%2C%20mixing%20console%2C%20on-air%20sign%2C%20spiritual%20atmosphere%2C%20professional%20radio%20equipment%2C%20gospel%20music%20theme&width=1200&height=400&seq=radio-banner-premium&orientation=landscape"
          alt="Rádios Web Evangélicas"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white">
            <h2 className="text-6xl font-bold mb-6 drop-shadow-2xl">📻 Rádios Web Evangélicas</h2>
            <p className="text-3xl opacity-95 mb-4 drop-shadow-lg">Ouça as melhores estações cristãs online</p>
            <p className="text-xl opacity-85 mb-3">Música gospel, pregações e programação cristã 24 horas</p>
            <p className="text-lg opacity-75 mt-4 bg-black/30 px-6 py-2 rounded-full inline-block">🌐 Acesso direto aos sites das rádios</p>
          </div>
        </div>
      </div>

      {/* Main Content Premium */}
      <div className="max-w-8xl mx-auto px-8 py-12">
        {/* Instructions Premium */}
        <div className="bg-white/98 backdrop-blur-lg rounded-3xl shadow-2xl p-8 border border-white/30 mb-12">
          <h3 className="text-3xl font-bold bg-gradient-to-r from-purple-600 via-pink-600 to-red-600 bg-clip-text text-transparent mb-6">
            🎧 Como Ouvir
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mouse-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">1. Clique na Estação</h4>
              <p className="text-gray-600">Escolha sua rádio evangélica favorita</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-r from-pink-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-external-link-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">2. Acesse o Site</h4>
              <p className="text-gray-600">Será redirecionado para o site oficial</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-r from-red-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-headphone-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">3. Ouça Online</h4>
              <p className="text-gray-600">Desfrute da programação cristã</p>
            </div>
          </div>
        </div>

        {/* Radio Stations Grid Premium */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {radioStations.map((station) => (
            <div
              key={station.id}
              className="bg-white/98 backdrop-blur-lg rounded-3xl shadow-2xl overflow-hidden border border-white/30 hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
            >
              <div className="aspect-[3/2] bg-gray-200 overflow-hidden">
                <img
                  src={station.image}
                  alt={station.name}
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                />
              </div>
              
              <div className="p-6">
                <h4 className="text-xl font-bold text-gray-800 mb-3">{station.name}</h4>
                <p className="text-gray-600 mb-4 leading-relaxed">{station.description}</p>
                
                <div className="flex items-center justify-between mb-6">
                  <span className="bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 px-3 py-1 rounded-full text-sm font-medium">
                    {station.genre}
                  </span>
                  <div className="flex items-center space-x-1 text-green-600">
                    <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                    <span className="text-sm font-medium">ONLINE</span>
                  </div>
                </div>

                <button
                  onClick={() => openRadioWebsite(station.website)}
                  className="w-full bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 text-white py-4 rounded-2xl font-bold text-lg hover:from-purple-600 hover:via-pink-600 hover:to-red-600 transition-all duration-300 shadow-2xl transform hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-external-link-line mr-3"></i>
                  Ouvir Agora
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Features Premium */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white/98 backdrop-blur-lg rounded-3xl shadow-2xl p-8 border border-white/30 text-center">
            <i className="ri-radio-line text-6xl text-purple-500 mb-4"></i>
            <h4 className="text-2xl font-bold text-gray-800 mb-4">Transmissão 24h</h4>
            <p className="text-gray-600 leading-relaxed">Programação cristã ininterrupta com música gospel, pregações e estudos bíblicos</p>
          </div>
          <div className="bg-white/98 backdrop-blur-lg rounded-3xl shadow-2xl p-8 border border-white/30 text-center">
            <i className="ri-music-line text-6xl text-pink-500 mb-4"></i>
            <h4 className="text-2xl font-bold text-gray-800 mb-4">Música Gospel</h4>
            <p className="text-gray-600 leading-relaxed">Os melhores hinos e cânticos cristãos para edificar sua fé e adorar a Deus</p>
          </div>
          <div className="bg-white/98 backdrop-blur-lg rounded-3xl shadow-2xl p-8 border border-white/30 text-center">
            <i className="ri-heart-line text-6xl text-red-500 mb-4"></i>
            <h4 className="text-2xl font-bold text-gray-800 mb-4">Palavra de Deus</h4>
            <p className="text-gray-600 leading-relaxed">Pregações inspiradoras e estudos bíblicos para fortalecer sua caminhada cristã</p>
          </div>
        </div>

        {/* Popular Stations Premium */}
        <div className="mt-16 bg-white/98 backdrop-blur-lg rounded-3xl shadow-2xl p-10 border border-white/30">
          <h3 className="text-3xl font-bold bg-gradient-to-r from-purple-600 via-pink-600 to-red-600 bg-clip-text text-transparent mb-8 text-center">
            ⭐ Estações Mais Populares
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {radioStations.slice(0, 4).map((station, index) => (
              <div
                key={station.id}
                className="flex items-center space-x-6 p-6 bg-gradient-to-r from-purple-50 via-pink-50 to-red-50 rounded-2xl border-2 border-purple-200 hover:shadow-xl transition-all duration-300"
              >
                <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                  {index + 1}
                </div>
                <div className="flex-1">
                  <h4 className="text-xl font-bold text-gray-800 mb-2">{station.name}</h4>
                  <p className="text-gray-600 mb-3">{station.description}</p>
                  <button
                    onClick={() => openRadioWebsite(station.website)}
                    className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-2 rounded-xl font-bold hover:from-purple-600 hover:to-pink-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-play-line mr-2"></i>
                    Ouvir
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
